export default function browserDetect() {
  const ua = navigator.userAgent.toLowerCase();

  if (ua.indexOf('safari') !== -1) {
    if (ua.indexOf('chrome') > -1) {
      return 'chrome';
    }
    return 'safari';
  }
  if (ua.indexOf('msie') > -1 || ua.indexOf('trident') > -1) {
    if (ua.indexOf('msie 10.0') > -1) {
      return 'ie-10';
    }
    return 'ie';
  }
  if (ua.indexOf('firefox') > -1) {
    return 'mozilla';
  }
  return 'standard';
}



// WEBPACK FOOTER //
// ./src/utils/browser.js